export default __webpack_public_path__ + "static/media/arabica-coffee.55b5a263.jpg";